/**
 * Fragment de routes du paquet v8c-p02-cles-api (vague V8c, règle R2 du découpage V4–V11 : un fragment par paquet).
 * Composants chargés à la demande (règle de chargement du registre). Routes neuves, aucun remplacement du socle :
 *  - `/org/cles-api` → organisation-cles-api ; `/org/cles-api/:cleId` → organisation-cle-api-fiche ;
 *  - dialogues en écran plein : `/org/creer-cle-api` (création ; pas sous `/org/cles-api/…`, qui chevaucherait la fiche)
 *    et `/org/cles-api/:cleId/remplacer`.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const OrganisationClesApi = lazy(() => import('../ecrans/v8c/clesapi/OrganisationClesApi'))
const OrganisationCleApiFiche = lazy(() => import('../ecrans/v8c/clesapi/OrganisationCleApiFiche'))
const DialogueCreerCleApi = lazy(() => import('../ecrans/v8c/clesapi/DialogueCreerCleApi'))
const DialogueRemplacerCleApi = lazy(() => import('../ecrans/v8c/clesapi/DialogueRemplacerCleApi'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v8c-clesapi',
  routes: [
    { chemin: '/org/cles-api', element: ecran(OrganisationClesApi) },
    { chemin: '/org/creer-cle-api', element: ecran(DialogueCreerCleApi) },
    { chemin: '/org/cles-api/:cleId', element: ecran(OrganisationCleApiFiche) },
    { chemin: '/org/cles-api/:cleId/remplacer', element: ecran(DialogueRemplacerCleApi) },
  ],
}
